<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Nova Capacitação
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>

        <lista-unidades-select v-model="unidade.nome"></lista-unidades-select>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Descrição</div>
        <q-input v-model="dados.descricao" dense outlined class="input" />
      </div>
      <div
        class="col-lg-2 col-md-2 col-sm-7 col-xs-7 text-brand-5 text-weight-bold"
      >
        <div class="q-ml-sm texto-titulo-input">Data Aplicação</div>
        <q-input
          dense
          outlined
          class="input"
          placeholder="DD/MM/AAAA"
          v-model="dados.dataAplicacao"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="dados.dataAplicacao"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div>
        <p></p>
        <q-btn
          label="Criar"
          color="positive"
          icon="add"
          no-caps
          class="q-mt-sm btn"
          @click="criarCapacitacao()"
        />
      </div>
    </div>
    <div class="row col-12 q-gutter-x-xs">
      <div class="q-mt-xl col-md col-xs-12 col-sm-12 tabela-grupo">
        <div class="row col-12 q-my-lg justify-between items-center">
          <span
            class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
          >
            Selecione o Treinamento
          </span>
          <div
            class="row col-12 justify-end text-brand-5 text-weight-bold q-mb-sm container-input-search"
          >
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              type="text"
              v-model="busca.buscaTreinamento"
              class="col-md-5 col-xs-12"
              placeholder="Pesquisar"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
        </div>
        <q-table
          :columns="columns"
          :rows="listaTreinamentos"
          color="primary"
          class="tabela-tamanho-fixo"
          table-header-class="bg-accent text-weight-bold"
          flat
          dense
          hide-bottom
          row-key="nome"
          selection="multiple"
          :loading="loading"
          v-model:selected="treinamentoSelecionados"
          :grid="$q.screen.lt.sm"
          hide-pagination
          v-model:pagination="pagination"
          :rows-per-page-options="[0]"
        >
          <template v-slot:item="props">
            <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
              <div class="row card text-grid-table text-brand-5 q-pa-sm">
                <div
                  class="row col-12 justify-center items-center justify-between"
                >
                  <div class="col-8">
                    <span class="row col-12 q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Nome: </strong>
                      {{ props.row.nome }}</span
                    >
                    <span class="row col-12 q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Descrição: </strong>
                      {{ props.row.descricao }}</span
                    >
                    <span class="row col-12 items-center q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Instrutor: </strong>
                      <input
                        v-model="props.row.instrutor"
                        type="text"
                        class="input-grid"
                    /></span>
                    <span class="row col-12 items-center q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Instrutor Id: </strong>
                      <input
                        v-model="props.row.instrutorId"
                        type="text"
                        class="input-grid"
                    /></span>
                    <span class="row col-12 items-center q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Reciclagem: </strong>
                      <input
                        style="height: 18px; width: 18px; margin-left: 5px"
                        type="checkbox"
                        class="checkbox"
                        v-model="props.row.reciclagem"
                    /></span>
                  </div>
                  <div class="col-4">
                    <div class="row col-12 justify-end">
                      <q-checkbox
                        :val="props.row"
                        v-model="treinamentoSelecionados"
                        icon="add_circle"
                        color="blue-8"
                        style="margin-left: 4px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th
                class="text-weight-bolder"
                v-for="col in props.cols"
                :key="col.name"
                :props="props"
              >
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>
                <q-checkbox
                  :val="props.row"
                  v-model="treinamentoSelecionados"
                  icon="add_circle"
                  color="blue-8"
                  style="margin-left: 4px"
                />
              </q-td>
              <q-td>
                <span> {{ props.row.nome }}</span>
              </q-td>
              <q-td>
                <span> {{ props.row.descricao }}</span>
              </q-td>
              <q-td>
                <q-input
                  dense
                  outlined
                  v-model="props.row.instrutor"
                  style="width: 110px"
                />
              </q-td>
              <q-td>
                <q-input
                  dense
                  outlined
                  v-model="props.row.instrutorId"
                  style="width: 90px"
                />
              </q-td>
              <q-td>
                <input
                  style="
                    height: 22px;
                    width: 22px;
                    margin-left: 20px;
                    margin-top: 3px;
                  "
                  type="checkbox"
                  class="checkbox"
                  v-model="props.row.reciclagem"
                />
              </q-td>
              <q-td>
                <span>
                  {{
                    props.row.validade == 1
                      ? `${props.row.validade} Dia`
                      : `${props.row.validade} Dias`
                  }}</span
                >
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <div class="row justify-start q-mt-md">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            size="sm"
          />
        </div>
      </div>
      <div class="q-mt-xl col-md col-xs-12 col-sm-12 tabela-grupo">
        <div class="row col-12 q-my-lg justify-between items-center">
          <span
            class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
          >
            Selecione os Participantes Presentes
          </span>
          <div
            class="row col-12 justify-end text-brand-5 text-weight-bold q-mb-sm container-input-search"
          >
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              type="text"
              v-model="busca.buscaParticipante"
              class="col-md-5 col-xs-12"
              placeholder="Pesquisar"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
        </div>
        <q-table
          :columns="columns2"
          :rows="listaUsuarios"
          color="primary"
          table-header-class="bg-accent text-weight-bold"
          flat
          hide-bottom
          class="tabela-tamanho-fixo"
          dense
          row-key="nome"
          selection="multiple"
          :loading="loading"
          v-model:selected="pessoasSelecionadas"
          :grid="$q.screen.lt.sm"
          v-model:pagination="pagination2"
          :rows-per-page-options="[0]"
        >
          <template v-slot:item="props">
            <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
              <div class="row card text-grid-table text-brand-5 q-pa-sm">
                <div
                  class="row col-12 justify-center items-center justify-between"
                >
                  <div class="col-8">
                    <span class="row col-12 q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Nome: </strong>
                      {{ props.row.name }}</span
                    >
                    <span class="row col-12 q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Id: </strong>
                      {{ props.row.sap }}</span
                    >
                    <span class="row col-12 q-ml-sm q-mt-sm"
                      ><strong class="q-mr-xs">Email: </strong>
                      {{ props.row.email }}</span
                    >
                  </div>
                  <div class="col-4">
                    <div class="row col-12 justify-end">
                      <q-checkbox
                        :val="props.row.id"
                        v-model="pessoasSelecionadas"
                        icon="add_circle"
                        color="blue-8"
                        style="margin-left: 4px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th
                class="text-weight-bolder"
                v-for="col in props.cols"
                :key="col.name"
                :props="props"
              >
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>
                <q-checkbox
                  :val="props.row.id"
                  v-model="pessoasSelecionadas"
                  icon="add_circle"
                  color="blue-8"
                  style="margin-left: 4px"
                />
              </q-td>
              <q-td>
                <span> {{ props.row.name }}</span>
              </q-td>
              <q-td>
                <span> {{ props.row.sap }}</span>
              </q-td>
              <q-td>
                <span> {{ props.row.email }}</span>
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <div class="row justify-end q-mt-md">
          <q-pagination
            :disable="disable2"
            v-model="pagination2.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber2"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            size="sm"
          />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

const columns = [
  {
    name: "selecionar",
    label: "Selecionar",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "instrutor",
    label: "Instrutor",
    align: "left",
  },
  {
    name: "instrutorId",
    label: "Instrutor ID",
    align: "left",
  },
  {
    name: "reciclagem",
    label: "Reciclagem",
    align: "left",
  },
  {
    name: "validade",
    label: "Validade",
    align: "left",
  },
];

const columns2 = [
  {
    name: "selecionar",
    label: "Selecionar",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "id",
    label: "ID",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    align: "left",
  },
];
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const dados = ref({
      dataAplicacao: new Date().toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
      descricao: `Nova Aplicação de Treinamentos - ${new Date().toLocaleDateString(
        "pt-BR",
        {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }
      )}`,
    });

    const busca = ref({ buscaParticipante: "", buscaTreinamento: "" });
    const listaTreinamentos = ref([]);
    const listaUsuarios = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 10,
    });
    let disable = ref(false);
    let loading = ref(false);
    const pagination2 = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 10,
    });
    let disable2 = ref(false);
    let loading2 = ref(false);
    const treinamentoSelecionados = ref([]);
    const pessoasSelecionadas = ref([]);

    const listarTreinamentos = async (page = 0, rowsNumber = 10) => {
      await unidade.value.id;
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch(
          "treinamento/listarTreinamentos",
          {
            unidadeId: unidade.value.id,
            treinamento: busca.value.buscaTreinamento,
            per_page: rowsNumber,
            page: page,
          }
        );
        listaTreinamentos.value = response.data.data;
        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.page = response.data.current_page;
        pagination.value.rowsNumber = response.data.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarUsuarios = async (page = 0, rowsNumber = 10) => {
      await unidade.value.id;
      try {
        loading2.value = true;
        disable2.value = true;
        const response = await store.dispatch("treinamento/listarUsuarios", {
          vendor_id: unidade.value.id,
          per_page: rowsNumber,
          page: page,
          search: busca.value.buscaParticipante,
        });
        listaUsuarios.value = response.data.results.data;
        pagination2.value.rowsPerPage = response.data.results.per_page;
        pagination2.value.page = response.data.results.current_page;
        pagination2.value.rowsNumber = response.data.results.total;
        loading2.value = false;
        disable2.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const criarCapacitacao = async () => {
      if (treinamentoSelecionados.value == "") {
        quasar.notify({
          message: "Selecione ao menos um treinamento",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (pessoasSelecionadas.value == "") {
        quasar.notify({
          message: "Selecione ao menos uma pessoa",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("treinamento/criarCapacitacao", {
          funcionarios: pessoasSelecionadas.value,
          treinamentos: treinamentoSelecionados.value,
          unidadeId: unidade.value.id,
          descricao: dados.value.descricao,
        });
        let id = response.data.data.id;
        quasar.notify({
          message: "Capacitação criada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        finalizarCapacitacao(id);
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao criar capacitação",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const finalizarCapacitacao = async (capacitacaoId) => {
      try {
        const response = await store.dispatch(
          "treinamento/finalizarCapacitacao",
          {
            capacitacaoId: capacitacaoId,
            dataRealizacao: dados.value.dataAplicacao,
          }
        );
        reset();
        let id = response.data.data.id;
        router.push({
          name: "treinamento-detalhe-capacitacao",
          params: { capacitacaoId: id },
        });
      } catch (error) {
        console.log(error);
      }
    };

    const reset = () => {
      dados.value = {
        dataAplicacao: new Date().toLocaleString("pt-br").split(" ")[0],
        descricao: `Nova Aplicação de Treinamentos - ${
          new Date().toLocaleString("pt-br").split(" ")[0]
        }`,
      };
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        listarTreinamentos();
        listarUsuarios();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarTreinamentos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => pagination2.value.page,
      () => {
        listarUsuarios(pagination2.value.page, pagination2.value.rowsPerPage);
      }
    );

    watch(
      () => busca.value.buscaParticipante,
      () => {
        listarUsuarios();
      }
    );

    watch(
      () => busca.value.buscaTreinamento,
      () => {
        listarTreinamentos();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    onMounted(listarTreinamentos);
    onMounted(listarUsuarios);

    return {
      columns,
      columns2,
      dados,
      unidade,
      listarTreinamentos,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      pagination2,
      pagesNumber2: computed(() =>
        Math.ceil(pagination2.value.rowsNumber / pagination2.value.rowsPerPage)
      ),
      disable2,
      loading2,
      listaTreinamentos,
      treinamentoSelecionados,
      busca,
      pessoasSelecionadas,
      listarUsuarios,
      listaUsuarios,
      criarCapacitacao,
      finalizarCapacitacao,
      reset,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }

  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .btn {
    margin: 8px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .input-grid {
    width: 70px;
    outline: none;
  }
}
</style>
